import React, { useRef, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

interface InfoTooltipProps {
  content: React.ReactNode;
  placement?: Placement;
  wide?: boolean;
}

const wideStyle = { '--bs-popover-max-width': 'none' } as React.CSSProperties;

const InfoTooltip = ({ content, placement = 'right', wide }: InfoTooltipProps) => {
  const [show, setShow] = useState(false);
  const hideTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelHide = () => {
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current);
      hideTimeout.current = null;
    }
  };

  const scheduleHide = () => {
    hideTimeout.current = setTimeout(() => setShow(false), 150);
  };

  const overlay = (
    <Popover className="border" {...(wide ? { style: wideStyle } : {})} onMouseEnter={cancelHide} onMouseLeave={scheduleHide}>
      <Popover.Body className="small py-2 px-3">
        {content}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement={placement} show={show} overlay={overlay}>
      <i
        className="bi bi-info-circle text-muted"
        style={{ cursor: 'pointer' }}
        data-testid="info-tooltip"
        onMouseEnter={() => { cancelHide(); setShow(true); }}
        onMouseLeave={scheduleHide}
      />
    </OverlayTrigger>
  );
};

export default InfoTooltip;
